import { AllUsersResponseModel } from "../pages/shared/models/api/all-users-response.model";
import { UserAddressUpdateMeta } from "./user-addresses.service";
import axiosInstance from "../router/interceptor";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:4001/bls";

async function createUser(data: any, languageId: number) {
  try {
    const dataCopy = { ...data };
    dataCopy.locationId = dataCopy.locationId
      ? dataCopy.locationId.countryId
      : undefined;

    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.post(
      `${API_URL}/users/insert`,
      { languageId, user: dataCopy },
      authorizationHeader,
    );
  } catch (error) {
    console.error(error);
  }
}

async function editUser(userId: number, userUpdateData: any) {
  const userClone: { [key: string]: any } = { ...userUpdateData };

  delete userClone.userId;

  Object.keys(userClone).forEach((modifiedField) => {
    if (userClone[modifiedField] === undefined) {
      userClone[modifiedField] = null;
    }
    if (modifiedField === "warehouse" && userClone[modifiedField]) {
      userClone[modifiedField] = userClone[modifiedField].warehouseId;
    }
    if (modifiedField === "locationId" && userClone[modifiedField]) {
      userClone[modifiedField] = userClone[modifiedField].countryId;
    }
  });

  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance
      .put(`${API_URL}/users/${userId}`, userClone, authorizationHeader)
      .then((response) => response?.data as UserUpdateMeta);
  } catch (error) {
    console.error(error);

    return {
      acknowledged: false,
      matchedCount: 0,
      modifiedCount: 0,
      upsertedCount: 0,
      upsertedId: 0,
    };
  }
}

async function getAllUsers(
  filter: any,
  limit?: number,
  page?: number,
): Promise<AllUsersResponseModel> {
  try {
    const authorizationHeader = configAuthorizationHeader();
    const params = new URLSearchParams();

    if (limit) {
      params.append("limit", "" + limit);
    }
    params.append("page", "" + (page || 0));

    return axiosInstance
      .post(`${API_URL}/users`, { filter }, { params, ...authorizationHeader })
      .then((response) => {
        return response?.data as AllUsersResponseModel;
      });
  } catch (error) {
    console.error(error);

    return {
      currentPage: 0,
      users: [],
      pageSize: 0,
      totalItems: 0,
    };
  }
}

async function getUserById(userId: number) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.get(`${API_URL}/users/${userId}`, authorizationHeader);
  } catch (error) {
    console.error(error);
  }
}

async function getCurrentUser() {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance.get(`${API_URL}/users/current`, authorizationHeader);
  } catch (error) {
    console.error(error);
  }
}

async function changePassword(userId: number | undefined, data: object) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance
      .put(
        `${API_URL}/users/change-password/${userId}`,
        data,
        authorizationHeader,
      )
      .then((response) => {
        return response?.data as UserAddressUpdateMeta;
      });
  } catch (error) {
    console.error(error);
  }
}

async function changDefaultDeliveryWarehouseId(
  userId: number | undefined,
  data: object,
) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance
      .put(`${API_URL}/users/${userId}`, data, authorizationHeader)
      .then((response) => {
        return response?.data as UserAddressUpdateMeta;
      });
  } catch (error) {
    console.error(error);
  }
}

async function checkUserForExistence(filter: object = {}) {
  try {
    const authorizationHeader = configAuthorizationHeader();
    return axiosInstance
      .post(`${API_URL}/users/check-existence`, { filter }, authorizationHeader)
      .then((response) => {
        return response?.data?.exists as boolean;
      });
  } catch (error) {
    console.error(error);
  }
}

function configAuthorizationHeader() {
  let token = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  token = token ? token.replaceAll('"', "") : "";
  return {
    headers: {
      Authorization: "Bearer ".concat(token),
      "x-refresh-token": refreshToken,
    },
  };
}

export default {
  createUser,
  editUser,
  getAllUsers,
  getUserById,
  getCurrentUser,
  changePassword,
  changDefaultDeliveryWarehouseId,
  checkUserForExistence,
};

export interface UserUpdateMeta {
  acknowledged: boolean;
  matchedCount: number;
  modifiedCount: number;
  upsertedCount: number;
  upsertedId: number;
}
